import {combineReducers} from 'redux';
import {
  SET_VISIT_DATE,
  SET_VISIT_COMMENTS,
  SET_VISIT_REMINDER_EMAIL,
  SET_VEHICLE_MAKE,
  SET_VEHICLE_MODEL,
  SET_VEHICLE_COLOR
} from '../actionTypes/visit';


export default combineReducers({
  date(state = null, action) {
    switch (action.type) {
      case SET_VISIT_DATE:
        return action.value;
      default:
        return state;
    }
  },
  comments(state = null, action) {
    switch (action.type) {
      case SET_VISIT_COMMENTS:
        return action.value;
      default:
        return state;
    }
  },
  reminderEmail(state = false, action) {
    switch (action.type) {
      case SET_VISIT_REMINDER_EMAIL:
        return action.value;
      default:
        return state;
    }
  },
  vehicle: combineReducers({
    make(state = null, action) {
      switch (action.type) {
        case SET_VEHICLE_MAKE:
          return action.value;
        default:
          return state;
      }
    },
    model(state = null, action) {
      switch (action.type) {
        case SET_VEHICLE_MODEL:
          return action.value;
        default:
          return state;
      }
    },
    color(state = null, action) {
      switch (action.type) {
        case SET_VEHICLE_COLOR:
          return action.value;
        default:
          return state;
      }
    }
  })
});


// WEBPACK FOOTER //
// ./src/reducers/visit.js